import axios from 'axios'
import { api_lp, api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'
import router from '../../router'
import moment from 'moment'

const tkdnStore = {
  namespaced: true,
  state: () => ({
    importModalShow: false,
    realisasiBelanja: [],
    belanjaDomestik: [],
    tkdnCategories: [],
    table: 'actual',
    server: null,

    start: null,
    end: null,
    code: null,
  }),
  mutations: {
    UPDATE_TKDN_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    UPDATE_QUERY(state, payload) {
      state.start = payload.start
      state.end = payload.end
      state.code = payload.code
    },
  },
  actions: {
    getRealisasiBelanja: async ({ commit, state, rootState }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      await commit('UPDATE_TKDN_DATA', {
        name: 'realisasiBelanja',
        value: [],
      })

      let dateQuery = ''
      if (payload && payload.end && payload.start) {
        dateQuery = `&end=${payload.end}&start=${payload.start}`
      }

      if (payload && payload.bc) {
        dateQuery += `&bc=${payload.bc}`
      }

      if (payload && payload.server) {
        dateQuery += `&server=${payload.server}`
      }

      const url = `${api}/api/v1/dashboard/tkdn/realisasi-belanja?table=${state.table}${dateQuery}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('UPDATE_TKDN_DATA', {
          name: 'realisasiBelanja',
          value: data.data,
        })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit('UPDATE_TKDN_DATA', {
          name: 'realisasiBelanja',
          value: [],
        })
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    getBelanjaDomestik: async ({ commit, state, rootState }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      await commit('UPDATE_TKDN_DATA', {
        name: 'belanjaDomestik',
        value: [],
      })

      let dateQuery = ''
      if (payload && payload.end && payload.start) {
        dateQuery += `&end=${payload.end}&start=${payload.start}`
      }

      if (payload && payload.bc) {
        dateQuery += `&bc=${payload.bc}`
      }

      if (payload && payload.server) {
        dateQuery += `&server=${payload.server}`
      }
      const url = `${api}/api/v1/dashboard/tkdn/belanja-domestik?table=${state.table}${dateQuery}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('UPDATE_TKDN_DATA', {
          name: 'belanjaDomestik',
          value: data.data,
        })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit('UPDATE_TKDN_DATA', {
          name: 'belanjaDomestik',
          value: [],
        })
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    getTkdnCategories: async ({ commit, state, rootState }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      await commit('UPDATE_TKDN_DATA', {
        name: 'tkdnCategories',
        value: [],
      })

      let query = ''
      if (payload && payload.end && payload.start) {
        query += `&end=${payload.end}&start=${payload.start}`
      } else {
        let endDate = new Date()
        let startDate = new Date()
        startDate.setFullYear(startDate.getFullYear() - 2)
        startDate = moment(startDate).format('YYYY-MM-DD')
        endDate = moment(endDate).format('YYYY-MM-DD')

        query += `&end=${endDate}&start=${startDate}`
      }

      if (payload && payload.bc) {
        query += `&bc=${payload.bc}`
      }

      if (payload && payload.server) {
        query += `&server=${payload.server}`
      }

      const url = `${api}/api/v1/dashboard/tkdn/esdm?table=${state.table}${query}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('UPDATE_TKDN_DATA', {
          name: 'tkdnCategories',
          value: data.data,
        })
        await commit('UPDATE_QUERY', {
          start: payload && payload.start,
          end: payload && payload.end,
          code: payload && payload.bc,
        })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit('UPDATE_TKDN_DATA', {
          name: 'tkdnCategories',
          value: [],
        })
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
  },
}

export default tkdnStore
